import React, { useEffect, useCallback } from 'react';
import './schedule.css';
import { useDispatch, useSelector } from "react-redux";
import Service from "../Service/Service";
import { setScheduleAction } from "../../redux/actions";
import { SCHEDULE_INITIAL } from "../../redux/initialStateConstants";
import {
    getTimetableSagaAction,
    getMastersSagaAction,
    getServicesSagaAction,
    addScheduleReserveSagaAction
} from "../../redux/sagaActions";
import Master from "../Master/Master";
import Timetable from "../Timetable/Timetable";

const Schedule = () => {
    const dispatch = useDispatch();
    const schedule = useSelector(state => state.schedule);

    // Проверка возможности записи на услугу
    const checkBookingAble = useCallback(() => {
        return (schedule.selected_services.length > 0 && schedule.selected_master > 0 && schedule.date !== '' && schedule.selected_time !== '');
    }, [schedule]);

    useEffect(() => {
        dispatch(getServicesSagaAction());
    },[dispatch]);

    return (
        <div className="form">
            <div className="form__scrollable">
                <div className="form__content schedule">
                    <div className="form__header">
                        <div className="form__close"
                            onClick={ () => {
                                dispatch(setScheduleAction(SCHEDULE_INITIAL));
                            } }
                        />
                        <div className="form__title">Расписание</div>
                    </div>
                    <div className="schedule__content">
                        <div className="schedule__tabs">
                            <div className="tabs">
                                <div className={ `tab ${ schedule.stage === 'services' && 'tab--active' }`}
                                    onClick={ () => {
                                        if (schedule.stage === 'services') return;
                                        dispatch(getServicesSagaAction());
                                    } }
                                >Услуги</div>
                                <div className={ `tab ${ schedule.stage === 'masters' && 'tab--active' }` }
                                    onClick={ () => {
                                        if (schedule.stage === 'masters') return;
                                        dispatch(getMastersSagaAction());
                                    } }
                                >Мастера</div>
                                <div className={ `tab ${ schedule.stage === 'timetable' && 'tab--active' }` }
                                     onClick={ () => {
                                         if (schedule.stage === 'timetable') return;
                                         dispatch(getTimetableSagaAction());
                                     } }
                                >Дата и время</div>
                            </div>
                        </div>
                        {
                            schedule.stage === 'services'
                            ?
                            <div className="services__items">
                                {
                                    schedule.services.map(elem => (
                                        <Service key={ elem.id } data={ elem } />
                                    ))
                                }
                            </div>
                            :
                            schedule.stage === 'masters'
                            ?
                            <div className="masters__items">
                                {
                                    schedule.masters.map(elem => (
                                        <Master key={ elem.id } data={ elem } />
                                    ))
                                }
                            </div>
                            :
                            schedule.stage === 'timetable'
                            ?
                            <Timetable/>
                            : false
                        }
                        <div className={ `schedule__submit button ${ !checkBookingAble() ? 'button--inactive' : '' }` }
                             onClick={ () => {
                                 dispatch(addScheduleReserveSagaAction());
                             } }
                        >Записаться</div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Schedule;